<template>
  <div id="buygGroup">
	<h1>Покупка R$ через группу</h1>	
	<div class="form wa" v-if="state === 'findGroup'">
	  <div class="sub">
	    Внимание, чтобы купить R$ этим способом, придется вступить в группу!
	    <br />
	    Мы сможем зачислить вам R$ только после 14 дней вступления в группу.
	    <br />
	    Мы рекомендуем использовать этот способ если вы уже вступали в группу.
	  </div>
	  <div class="sub">
        Курс обмена:
        <span class="t-white">
          1 <span class="t-green">₽</span> - {{ $root.common.groupRate }}
          <span class="t-red">R$</span>
        </span>
      </div>
	  <div class="sector bg-darker wa">
		<div class="fs30 t-light">Введите ваш ник</div>
		<input type="text" class="bg-darker wa" placeholder="myname" v-model="nickname" />
	  </div>
	  <button class="fs24 wa" @click="findGroup">Найти группу</button>
	</div>
  	<div v-if="state === 'joinGroup'" class="section wa">
	  <div class="sub">Вступите в <a :href="groupUrl" target="_blank">группу</a></div>
	  <button class="fs24 wa" @click="findGroup">Проверить</button>
	</div>
	<div class="section wa" v-if="state === 'buy'">
	  <div class="sector bg-darker wa">
	    <div class="fs30 t-light">Промокод (если есть)</div>
        <input type="text" class="bg-darker wa" v-model="promo" />
      </div>
	  <PriceCalculator @amount="a => amount = a" :rate="$root.common.groupRate" />
	  <div class="sub t-red" v-if="!group.canSend">Внимание, вы недавно вступили в группу, потребуется некоторое время, чтобы обработать ваш запрос (до 14 дней).</div>
    <PayWays @method="x => method = x"></PayWays>
	  <button class="fs24 wa" @click="buy">Перейти к оплате</button>
	</div>
  </div>
</template>

<script>
import PriceCalculator from "@/components/PriceCalculator";
import PayWays from "@/components/PayWays";
import { GetAvailableGroupForUserRequest } from "@/protos/user_pb.js";

export default {
  components: {
    PayWays,
    PriceCalculator,
  },

  data() {
	return {
    method: "lava",
	  group: null,
	  nickname: "",
	  state: "findGroup",
	  amount: 0,
	  promo: ""
	}
  },

  computed: {
	groupUrl() {
	  return `https://web.roblox.com/groups/${this.group.id}/1`
	}
  },

  methods: {
	buy() {
	  this.$root.startBuildingOrder({ method: this.method, nickname: this.nickname, group: this.group, amount: this.amount, promo: this.promo })
	},

	findGroup() {
  	  if (!this.nickname.length)
  	    return
  	  this.nickname = this.nickname.trim()
  	  // check if user has an associated group
  	  const r = new GetAvailableGroupForUserRequest()
	  r.setNickname(this.nickname)

	  if (this.group)
		r.setGroupId(this.group.id)

	  this.$root.client.getAvailableGroupForUser(r, {}, (err, data) => {
		if (err)
		  return this.$root.toast.error(`Ошибка ${err}`)
		const id = data.getGroupId()
		const joined = data.getJoined()
		const canSend = data.getCanSend()
		
		if (!joined)
		  this.$root.toast.warning("Вы еще не вступили в группу.")

		this.group = { id, joined, canSend }
		this.state = joined ? "buy" : "joinGroup"
	  })
	}
  }
}
</script>
